module.exports = __webpack_public_path__ + "img/im_scrollfeature_04.bb5633b6.jpg";